import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=f4649160&scoped=true"
import script from "./ChatConversation.vue?vue&type=script&lang=ts"
export * from "./ChatConversation.vue?vue&type=script&lang=ts"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=f4649160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4649160",
  null
  
)

export default component.exports